import React from 'react';
import * as Yup from 'yup';
import { useFormatMessage } from 'components/IntlProvider';
import { Input, Button } from '@deeptrue-frontend/ui';
import { FormatMessage } from 'components/IntlProvider/hooks/hooks';
import { Formik, Field as FormikField, FormikHelpers } from 'formik';

interface FormValues {
  tokens: number;
}

interface Props {
  onSubmit: (val: FormValues, helpers: FormikHelpers<FormValues>) => void;
  initialValues: FormValues;
}

const getValidationSchema = (t: FormatMessage) =>
  Yup.object().shape<FormValues>({
    tokens: Yup.number()
      .typeError('err')
      .positive('err')
      .required(t('errors.fields.required', 'Field is required')),
  });

const TokenRaise = ({ initialValues, onSubmit }: Props) => {
  const t = useFormatMessage();
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={getValidationSchema(t)}
    >
      {({ handleSubmit, isSubmitting, errors, touched }) => {
        return (
          <form onSubmit={handleSubmit}>
            <FormikField
              name="tokens"
              as={Input}
              hasError={errors.tokens && errors.tokens}
              helperText={touched.tokens && touched.tokens}
              placeholder="0"
              label={t(
                'organizations.creditsManagement.amount',
                'Amount of increase'
              )}
            />
            <Button ml="1rem" isLoading={isSubmitting} type="submit">
              {t('organizations.creditsManagement.raise', 'Raise')}
            </Button>
          </form>
        );
      }}
    </Formik>
  );
};

export default TokenRaise;
